// extracted by mini-css-extract-plugin
module.exports = {"stepper":"stepper-group-fragment_stepper_uOE5U"};